import { render, staticRenderFns } from "./reportPosition.vue?vue&type=template&id=2243dc6e&scoped=true"
import script from "./reportPosition.vue?vue&type=script&lang=js"
export * from "./reportPosition.vue?vue&type=script&lang=js"
import style0 from "./reportPosition.vue?vue&type=style&index=0&id=2243dc6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2243dc6e",
  null
  
)

export default component.exports